<template>
    <div class="t_content_view">
        <el-page-header @back="goBack" style="margin-bottom: 20px;">
            <template #content>
            <span > 查看数据 </span>
            </template>
        </el-page-header>
        <div class="custom-style">
            <el-segmented  v-model="searchdata.time_unit" :options="hmdate" :props="hmprops" size="large" @change="changeTimeUnit" />
        </div>
        
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%;margin-top: 20px;" v-loading="loading" >
            <el-table-column prop="generated_at" label="更新时间"></el-table-column>
            <el-table-column prop="add_quantity" label="添加数量"></el-table-column>
            <el-table-column prop="loss_quantity" label="流失数量"></el-table-column>
            
        </el-table>
         <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>

</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject } from 'vue'
import { ElMessage,ElMessageBox, ArrowDown } from 'element-plus'
import { qdhmlist,delqdhm,qdmlist,newgethmqdlist,newgethmcylist,newgethmlist,newgethmdel,newgethmdata } from '@/assets/js/common.js'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { variableDeclarator } from '@babel/types';
import { useRoute, useRouter } from 'vue-router'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //获取列表
    getlist()
   
    
})



//加载中
const loading = ref(false)
//列表数据
const tableData = reactive({
    data:[]
})
//成员总数
const total = ref(0)
//搜索
const searchdata = reactive({
   //当前页
    page:1,
    page_size:20,
    time_unit:'ymd',
    channel_code_id:route.query.id,
})

//筛选
const hmprops = {
  label: 'label',
  value: 'value',
}
const hmdate = [{label:'按日汇总',value:'ymd'}, {label:'按月汇总',value:'ym'}]
//筛选时间单位
const changeTimeUnit = (val)=>{
    searchdata.time_unit = val
    searchdata.page = 1
    //人员列表
    getlist()
}

//获取列表
const getlist = ()=>{
    loading.value = true
    newgethmdata(searchdata).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log(response.data)
            tableData.data = response.data.data.data
            // for(var i =0;i<tableData.data.length;i++){
                // tableData.data[i].member_ids=tableData.data[i].member_ids.split(',')
            // }
            total.value = response.data.data.total
            
        }
        loading.value = false
    })
}
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}

//返回
const goBack = ()=>{
    router.push({path:'/navtkyl/ewmlist'})
}



</script>
<style scoped>


:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.el-dropdown-menu{
    background-color: rgba(0, 0, 0, 0.8);
    
}
:deep(.el-dropdown-menu__item) {
    color:white !important
}
:deep( .el-dropdown-menu__item:not(.is-disabled):focus ){
        background-color: black;
        color: white;
    }

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

/* .t_content_view {
    padding: 20px;
} */

/* .t_cz_box {
    display: flex;
    justify-content:space-around
} */

.t_all_tag {
    margin-top: 10px;
    margin-right: 10px;
}

.t_tagchoose_box {
    margin-bottom: 30px
}

.t_more_img {
    display: flex;
    flex-wrap: wrap;
}

.t_more {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    border: 1px solid white;
    border-radius: 50%;
    background-color: rgb(206, 206, 206);
    text-align: center;
    line-height: 30px;
}

.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
}
.custom-style .el-segmented {
  --el-segmented-item-selected-color: var(--el-text-color-primary);
  --el-segmented-item-selected-bg-color: white;
  --el-border-radius-base: 5px;
}
</style>